//sprite size in px
export const SPRITE_SIZE = 64

//determines map height & width based on sprite size and amount of rows on map
export const MAP_HEIGHT = SPRITE_SIZE * 15
export const MAP_WIDTH = SPRITE_SIZE * 15


//sets the height & width of the image to be used by sprite sheet
export const SPRITE_SHEET_HEIGHT = 1344
export const SPRITE_SHEET_WIDTH = 832
//sets the amount of colums and rows on the sprite sheet
export const width = SPRITE_SHEET_WIDTH / 13;
export const height = SPRITE_SHEET_HEIGHT / 21;